import { useEffect, useState } from "react";
import {
  MyCoursesSummaryInterface,
  DataType,
  LetterCertificateOptions,
} from "../../interfaces/my-courses-summary.interface";
import { Button, TableColumnsType } from "antd";
import { defaultColumns } from "./utils";
import moment from "moment";
import { getImage } from "../../services/image-utils";
import { gradeStatusOptions } from "../../constants/grades.constants";
import { getCoursesSummaryByStudent } from "../../services/students-courses.service";
import { useNavigate } from "react-router-dom";
import "../shared/CBShared.style.scss";

export function useCoursesSummary() {
  const navigate = useNavigate();
  const [details, setDetails] = useState<MyCoursesSummaryInterface[]>();
  const [dataset, setDataset] = useState<DataType[]>();
  const [columns, setColumns] = useState<TableColumnsType<DataType>>();
  const [openModal, setOpenModal] = useState(false);
  const [options, setOptions] = useState<LetterCertificateOptions>();

  const certificateLogo = getImage("/assets/seabc_certificate.png");
  const letterLogo = getImage("/assets/seabc_letter.png");
  const certificateImg = getImage("/assets/seabc_certificate_alert.png");
  const letterImg = getImage("/assets/seabc_letter_alert.png");
  const buildDataset = (res: MyCoursesSummaryInterface[] | undefined) => {
    setDetails(res);
    setDataset(
      res?.map((item: MyCoursesSummaryInterface) => {
        const payments = item.payments.reduce(
          (acc, payment) => {
            if (payment.status === "Completed") {
              acc.completedAmount += payment.amount;
              acc.paymentType = payment.type;
              acc.receivedAt = `${payment.receivedAt}`;
            } else {
              acc.pendingAmount += payment.amount;
            }
            return acc;
          },
          {
            completedAmount: 0,
            paymentType: "N/A",
            receivedAt: "N/A",
            pendingAmount: 0,
          },
        );

        return {
          key: item.id,
          courseCode: item.course.code ?? "",
          courseName: item.course.name ?? "",
          registrationType: item.courseCost.registrationType ?? "",
          createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
          status: item.status ?? "",
          type: payments.paymentType,
          chequeReceived:
            payments.paymentType !== "Cheque"
              ? "N/A"
              : payments.receivedAt !== "N/A"
                ? "Yes"
                : "No",
          receivedAt:
            payments.paymentType === "Cheque" && payments.receivedAt !== "N/A"
              ? moment(payments.receivedAt).format("YYYY-MM-DD")
              : "",
          waitlist: item.waitlist.toString() ?? "",
          amount: (payments.completedAmount / 100).toFixed(2),
          balance: (payments.pendingAmount / 100).toFixed(2),
          options: (
            <div className="flex justify-center items-center gap-5">
              {(item.status === "Pending" ||
                item.status === "In Progress" ||
                item.status === "Unpaid" ||
                item.status === "Blocked") && (
                <Button
                  className="h-6 cb-background-blue"
                  type="primary"
                  onClick={() => {
                    navigate(`/SEABC/courses/${item.courseId}/registration`);
                  }}
                >
                  {item.status === "In Progress"
                    ? "Register"
                    : item.status === "Unpaid" || item.status === "Blocked"
                      ? "Pay Balance"
                      : "Pay Online"}
                </Button>
              )}
            </div>
          ),
          gradeStatus: gradeStatusOptions.includes(item.gradeStatus ?? "")
            ? (item.gradeStatus ?? "")
            : "Pending",
          finalGrade: item.studentGrades?.[5]?.grade ?? "0.00",
          actions: item.status === "Registered" &&
            item.gradeStatus === "Pass" && (
              <div className="flex justify-center items-center gap-5">
                {item.courseCost.registrationType === "In Class" ||
                item.courseCost.registrationType === "Webcast" ? (
                  <a href={"#"} className="text-sm">
                    <img
                      src={certificateLogo}
                      className="max-h-10"
                      onClick={() => {
                        setOpenModal(true);
                        setOptions({
                          type: "certificate",
                          courseId: item.course.id,
                          img: certificateImg,
                        });
                      }}
                    />
                  </a>
                ) : (
                  <a href={"#"} className="text-sm">
                    <img
                      src={letterLogo}
                      className="max-h-10"
                      onClick={() => {
                        setOpenModal(true);
                        setOptions({
                          type: "completion-letter",
                          courseId: item.course.id,
                          img: letterImg,
                        });
                      }}
                    />
                  </a>
                )}
              </div>
            ),
        };
      }),
    );
    setColumns(defaultColumns());
  };
  const getDataset = async () => {
    buildDataset(await getCoursesSummaryByStudent("0"));
  };
  useEffect(() => {
    getDataset();
    setOpenModal(false);
  }, []);

  return {
    details,
    dataset,
    columns,
    openModal,
    setOpenModal,
    options,
  };
}
